import { axiosInstance } from "@/config/axiosInstance";

export const loginTeamLeader = (data: { email: string; password: string }) =>
  axiosInstance
    .post<{ success: boolean; key: string; teamLeader: { _id: string; name: string; email: string } }>(
      "/teamleader/login",
      data,
      { headers: { "Content-Type": "application/json" } }
    )
    .then((response) => response.data);
